import { createFileRoute } from '@tanstack/react-router';
import { redirectToArio } from './-redirect';

/** @desc `/admin/automations` → `/admin/ario/` (D2), which lands on Workflows. */
export const Route = createFileRoute('/_protected/admin/automations/')({
  beforeLoad: ({ location }) => redirectToArio({ splat: '', location }),
});
